// Copyright ©️ 2026 eVolve MEP, LLC

import { Button, Text, Title } from '@mantine/core';

import { useAppNeedsRefresh } from 'components/Mantine/Navigation/useAppNeedsRefresh';

import { FullPageError } from './FullPageError';

export const ErrorPage = () => {
  const { hardRefresh } = useAppNeedsRefresh();
  const contactSupport = () => (window.location.href = 'https://evolvemep.com/contact-support');

  return (
    <FullPageError>
      <Title fz={80}>Uh oh</Title>
      <Text ta="center" mb="sm" fz="lg">
        Something went wrong.
      </Text>
      <Text ta="center">Information on this error has been captured and sent to Evolve so that it can be fixed.</Text>
      <Text ta="center">
        Refreshing the page typically resolves the issue. If the issue persists, please{' '}
        <Text span onClick={contactSupport} style={{ color: '#589CE4', cursor: 'pointer' }}>
          contact support.
        </Text>
      </Text>
      <Button color="dark" variant="filled" onClick={hardRefresh} mt="xl">
        Refresh page
      </Button>
    </FullPageError>
  );
};
